import { render } from "./Clock.svg?vue&type=template&id=28835cc1"
const script = {}
script.render = render

export default script